// 基础部分
import {
  changeCitiesWithEN as _changeCitiesWithEN,
  changeProvinceCityDistrict as _changeProvinceCityDistrict,
  changeProvincesCities as _changeProvincesCities,
} from '@/store/common';
import { getCityList as _getCityList, signFile as _signFile } from '@/common/api/common';
import { pcdList as _areaList } from '@/common/api/city';
import { get as _get, post as _post } from '@/common/request';
import { isApp as _isApp, isAppAndroid as _isAppAndroid } from '@/common/utils/ways';
import { isAppIOS as _isAppIOS } from '@/common/utils/tools';
export const getCityList = async() => {
  const res = await _getCityList();
  let data: any[] = [];
  if (res?.data?.cityList?.length) {
    data = data.concat(res.data.cityList);
  }
  if (res.data?.hotCityList?.length) {
    if (data.length) { // 有数据
      const hotCityIds = res.data.hotCityList.map(item => item.id);
      data = data.map((item: any) => {
        if (hotCityIds.includes(item.id)) {
          item.isDirect = 1;
        }
        return item;
      });
    } else {
      data = data.concat(res.data.hotCityList.map(item => {
        item.isDirect = 1;
        return item;
      }));
    }
  }
  return data || [];
};
export const areaList = (params: any) => {
  return new Promise((res, rej) => {
    _areaList(params).then((data: any) => {
      res(data.data);
    }, (err: any) => {
      rej(err);
    });
  });
};
export const isOss = process.env.STATIC_TYPE === 'oss';
export function changeProvinceCityDistrict(params: any): any {
  return _changeProvinceCityDistrict(params);
}
export function changeProvincesCities(params: any): any {
  return _changeProvincesCities(params);
}
export const signFile = _signFile;
export const get = _get;
export const post = _post;
export const isApp = _isApp;
export const isAppAndroid = _isAppAndroid;
export const isAppIOS = _isAppIOS;
// 项目是内嵌在哪里的，如果是多个app，就设置为 'any'
// 例如：设置location的话，location里面的video播放有提供定制化的客户端桥接时间 video，其他项目没有
// 其他项目如果有定制化，请找央木确认。
export const whatApp: string = 'location';

// 内联样式使用到calc()时，用来转换px成rem的计算公式
export function getPX2Rem(px: number) {
  return `${px / 75}rem`; // 公司项目都是用的 rootValue 75
}

export function getRem2Px(rem) {
  // 获取根元素（HTML）的计算后字体大小（默认通常是16px）
  const rootFontSize = parseFloat(
    getComputedStyle(document.documentElement).fontSize
  );
  // 返回REM值乘以根字体大小的结果
  return rem * rootFontSize + 'px';
}

/* 一些公用的格式后缀判断 */
export const specialDownloadTypes = ['dwg'];
export const canShowVideoFileTypes = ['mp4', '3gp', 'm3u8', 'mov'];
export const canShowImageFileTypes = ['png', 'jpg', 'gif', 'jpeg', 'bmp'];
export const officeView = ['ppt', 'pptx', 'doc', 'docx', 'xls', 'xlsx']; // 需要用微软的预览软件
export const pdfView = ['pdf'];

/* V1CityIndexBar */
export const cityValueKeyDefault = 'code';
export function changeCitiesWithEN(payload: any[]) {
  return _changeCitiesWithEN(payload);
}

/* V1FormUpload 配置 */

export const qiniuTokenUrl = '/v2/qiniu/token';
export const qiniuTokenExtraConfig = {
  needCancel: false,
};
export function analysis(res: any) {
  return res?.data?.token;
};
// 七牛文件夹名称
// 部分bucket不支持 '?imageView2/2/w/100/h/100/q/100/format/jpg'，对不不支持的请使用下面 UrlSuffix 提供的后缀（一般使用水印或缩略图后缀）
export enum Bucket {
  Default = 'linhuiba-certs',
}

// 地址后缀相关
// 除了原图，其他后缀的图片都是按照一定比例截取的，这个在七牛平台进行配置了
export enum UrlSuffix {
  linhuibaOri = '-linhuibaoriginal.jpg', // img.linhuiba.com水印
  Large = '-pms_wk',
  Ori = '-middlestage_original', // 原图
  Thn = '-middlestage_thn', // 缩略图
  /*
   * location私有的 suffix
  */
  locationOri = '-location_original', // location 原图
  /*
   * pms私有的 suffix
  */
  PmsOri = '-pms_original',

}

// 七牛文件夹映射的上传地址
export const bucketMappingDomain = {
  /*
   * 中台组的domain
  */
  'middlestage': 'https://middle-file.linhuiba.com/',
  /*
   * 邻汇吧组的domain
  */
  'linhui-fields': 'https://img.linhuiba.com/', //  场地相关文件
  'linhuiba-banners': 'https://banner.linhuiba.com/', //  内容文件
  'linhuiba-certs': 'https://cert.linhuiba.com/', //  证件文件
  'linhuiba-file': 'https://file.linhuiba.com/', //  excel、pdf等文件专用
  'linhuiba-temp': 'https://temp.linhuiba.com/', //  临时文件
  'linhuiba-video': 'https://videos.linhuiba.com/', //  视频文件
  /*
   * location的domain
  */
  'location-images': 'https://images.location.pub/', // 场地相关文件
  'location-cases': 'https://cases.location.pub/', // 案例文件
  'location-certs': 'https://certs.location.pub/', // 证件文件
  'location-files': 'https://files.location.pub/', // excel、pdf等文件专用
  'location-temp': 'https://temps.location.pub/', // 临时文件
  'location-videos': 'https://videos.location.pub/', // 视频文件
};

// 七牛文件夹映射的上传域名 https://developer.qiniu.com/kodo/manual/1671/region-endpoint
export const bucketMappingActionUrl: any = {
  /*
   * 中台组组的 的 qiniu地址
  */
  'middlestage': '//up-z2.qiniup.com/',
  /*
   * 邻汇吧组的 的 qiniu地址
  */
  'linhui-fields': '//upload.qiniup.com/', //  场地相关文件
  'linhuiba-banners': '//upload.qiniup.com/', //  内容文件
  'linhuiba-certs': '//upload.qiniup.com/', //  证件文件
  'linhuiba-crm': '//upload.qiniup.com/', //  crm相关文件
  // 华南：客户端上传：http(s)://upload-z2.qiniup.com
  'linhuiba-file': '//upload-z2.qiniup.com/', //  excel、pdf等文件专用
  'linhuiba-temp': '//upload-z2.qiniup.com/', //  临时文件
  'linhuiba-video': '//upload-z2.qiniup.com/', //  视频文件
  /*
   * location 的 qiniu地址
  */
  'location-images': '//upload-z2.qiniup.com/', // 场地相关文件
  'location-cases': '//up-z2.qiniup.com/', // 案例文件
  'location-certs': '//up-z2.qiniup.com/', // 证件文件
  'location-files': '//up-z2.qiniup.com/', // excel、pdf等文件专用
  'location-temp': '//up-z2.qiniup.com/', // 临时文件
  'location-videos': '//up-z2.qiniup.com/', // 视频文件
};

// 获取水印图片
// 目前的V1FormUpload中，仅image类型支持，file类型如果设置这个domain，会导致其余类型文件无法预览和下载，所以不需要支持
export const getWKQiniuImageUrl = (url: string) => {
  if (url && url.includes('img.linhuiba.com/')) {
    return url.includes(UrlSuffix.linhuibaOri) ? url : url + UrlSuffix.linhuibaOri;
  } else if (url && url.includes('pmsimage.location.pub/')) {
    return url.includes(UrlSuffix.PmsOri) ? url : url + UrlSuffix.PmsOri;
  } else if (url && url.includes('images.location.pub/')) {
    return url.includes(UrlSuffix.locationOri) ? url : url + UrlSuffix.locationOri;
  }
  return url;
};

/* 图表相关配置 */
export const themeColor: any = { // 主题的rgb颜色
  blue: ['#358AFF', '#39D3F9', '#FFA140', '#5366F6', '#80D6EB', '#FFEB58', '#A896EF'],
  blueRGB: [
    '53,138,255',
    '57,211,249',
    '255,161,64',
    '83,102,246',
    '128,214,235',
    '252,231,78',
    '168,150,239',
  ],
  blueGradient: ['#AED0FF', '#96C2FF', '#7EB4FF', '#65A6FF', '#4E98FF', '#358AFF'], // 漏斗图中的渐变主题色
  green: ['#0BB8AF', '#7BD2DE', '#FFD190', '#86CCFF', '#9FDEF4', '#FFBA96', '#FF8A8A'],
  greenRGB: [
    '11,184,175',
    '123,210,222',
    '255,209,144',
    '134,204,255',
    '159,222,244',
    '255,186,150',
    '255,138,138',
  ],
  greenGradient: ['#9DE3DF', '#80DAD5', '#63D2CC', '#45C9C2', '#29C1B9', '#0BB8AF'], // 漏斗图中的渐变主题色
  purple: ['#7087E4', '#C096E0', '#F3D296', '#F99090', '#BFC7FC', '#9298E9', '#FDB791'],
  purpleRGB: [
    '112,135,228',
    '192,150,224',
    '243,210,150',
    '249,144,144',
    '191,199,252',
    '146,152,233',
    '253,183,145',
  ],
  purpleGradient: ['#D3D6F6', '#C6C9F3', '#B9BDF1', '#ACB1EE', '#9FA5EC', '#9298E9'], // 漏斗图中的渐变主题色
};

// 高德key
// 商用版！！！
export const aMapKey: any = process.env.AMAP_KEY;

export async function getAMayKey() {
  return aMapKey;
}

export const typeMap = {
  'png,jpg,gif,jpeg,bmp': 'iconfile_icon_picture', // 图片
  'text': 'iconfile_icon_txt', // 文本
  'xls,xlsx': 'iconfile_icon_excel', // excel
  'doc,docx': 'iconfile_icon_word', // word文档
  'pdf': 'iconfile_icon_pdf', // pdf
  'ppt,pptx': 'iconfile_icon_ppt', // ppt
  'rar,zip,7z': 'iconfile_icon_zip', // 压缩包
  'mp4,m2v,mkv,rmvb,wmv,avi,flv,mov,m4v': 'iconfile_icon_video', // 视频
  'mp3,wav': 'iconfile_icon_music', // 音频
};

export function refactorQiniuImageUrl(url: string) {
  if (isOss) return url;
  if (typeof url === 'string') {
    if (url.indexOf('?') > -1) {
      const query = url.split('?')[1];
      if (query?.indexOf('imageView') > -1) { // 如果用户设置了，就不去管他
        return url;
      } else {
        return url + '&imageView2/1/w/152/h/152';
      }
    } else {
      return url + '?imageView2/1/w/152/h/152';
    }
  }
  return url;
};



export const fullEditorCss = `
  :host { all: initial; all: unset; }
  div,
  span,
  applet,
  object,
  iframe,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  blockquote,
  pre,
  a,
  abbr,
  acronym,
  address,
  big,
  cite,
  code,
  del,
  dfn,
  em,
  img,
  ins,
  kbd,
  q,
  s,
  samp,
  small,
  strike,
  strong,
  sub,
  sup,
  tt,
  var,
  b,
  u,
  i,
  center,
  dl,
  dt,
  dd,
  ol,
  ul,
  li,
  fieldset,
  form,
  label,
  legend,
  table,
  caption,
  tbody,
  tfoot,
  thead,
  tr,
  th,
  td,
  article,
  aside,
  canvas,
  details,
  embed,
  figure,
  figcaption,
  footer,
  header,
  hgroup,
  menu,
  nav,
  output,
  ruby,
  section,
  summary,
  time,
  mark,
  audio,
  video {
    margin: 0;
    padding: 0;
  }
  table {
    border-collapse: collapse;
    border-spacing: 0;
  }
  ul, ol {
    list-style-position: inside; /* 将列表标记内嵌 */
    padding-left: 0; /* 移除默认左边距 */
  }
  div, p, h1, h2, h3, h4, h5 {
    color: rgba(0, 0, 0, 0.85)
  }
  img {
    max-width: 100%;
  }
`;
